<template>
  <v-col cols="12">
    <MglMap
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      :zoom="zoom"
      :center="centerMap"
      style="width: 100%; height: 500px;"
      @load="onMapLoaded"
    >
      <MglMarker
        v-for="(fiscal, i) in localizacaoFiscais"
        :key="i"
        :coordinates="[
          fiscal.localizacao.longitude,
          fiscal.localizacao.latitude,
        ]"
      >
        <div slot="marker">
          <v-avatar>
            <img :src="fiscal.usuario.foto" :alt="fiscal.usuario.nomeUsuario" />
          </v-avatar>
        </div>
        <MglPopup>
          <v-card>
            <v-card-text>
              <p>Nome do Fiscal: {{ fiscal.usuario.nomeUsuario }}</p>
              <p>CPF do Fiscal: {{ fiscal.usuario.cpf }}</p>
              <p>E-mail do Fiscal: {{ fiscal.usuario.email }}</p>
            </v-card-text>
          </v-card>
        </MglPopup>
      </MglMarker>
    </MglMap>
  </v-col>
</template>

<script>
// import axios from "../plugins/axios";
import store from "@/store/index";
import { MglMap, MglPopup, MglMarker } from "vue-mapbox";
import "mapbox-gl/dist/mapbox-gl.css";

let mapa = null;

export default {
  components: {
    MglMap,
    MglMarker,
    MglPopup,
  },

  sockets: {
    reciveLocation: function(data) {
      this.localizacaoFiscais = this.localizacaoFiscais.filter(
        (localizacao) =>
          localizacao.usuario.numeroUsuario != data.usuario.numeroUsuario
      );
      this.localizacaoFiscais.push(data);
      this.centralizarMapa();
    },
  },

  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiZmVpb2t1biIsImEiOiJjanJtOWpsdzcwaDJsNDR0Mmh0ZGV1bzR2In0.XWAmqcgxDNyjq3Mg2XDE0g",
      mapStyle: "mapbox://styles/mapbox/streets-v11",
      coordinates: [-47.287163, -23.2695046],
      centerMap: [-47.287163, -23.2695046],
      localizacaoFiscais: [],
      zoom: 16,
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
    };
  },

  methods: {
    onMapLoaded: async function(map) {
      mapa = map.map;
    },

    centralizarMapa() {
      mapa.flyTo({
        center: [
          this.localizacaoFiscais[this.localizacaoFiscais.length - 1]
            .localizacao.longitude,
          this.localizacaoFiscais[this.localizacaoFiscais.length - 1]
            .localizacao.latitude,
        ],
      });
    },
  },
};
</script>
